
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Stratégie Facebook Ads : guide pour des campagnes réussies",
    description:
      "Découvrez comment créer des stratégies Facebook Ads performantes avec ALEO. Objectifs, formats, optimisation : maximisez vos résultats publicitaires !",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
